"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.expandedItemProcessor = void 0;
const dayjs = require("dayjs");
const currencyFormatter_1 = require("../currencyFormatter");
const getLatestOrderLineVersion_1 = require("./getLatestOrderLineVersion");
const getLinkedLineData_1 = require("./getLinkedLineData");
const getOrderDisplayCurrency_1 = require("./getOrderDisplayCurrency");
const getOrderLineCompletionStatus_1 = require("./getOrderLineCompletionStatus");
const getOrderLineCurrency_1 = require("./getOrderLineCurrency");
const getOrderLineData_1 = require("./getOrderLineData");
const getOrderLineDescriptions_1 = require("./getOrderLineDescriptions");
const getOrderLineDisplayTotal_1 = require("./getOrderLineDisplayTotal");
const getOrderLineEstimatedCheck_1 = require("./getOrderLineEstimatedCheck");
const getOrderLineIcon_1 = require("./getOrderLineIcon");
const getOrderLinePax_1 = require("./getOrderLinePax");
const getOrderLinePricingNote_1 = require("./getOrderLinePricingNote");
const getOrderLineSupplier_1 = require("./getOrderLineSupplier");
const getOrderLineTitle_1 = require("./getOrderLineTitle");
const getOrderLineTitleSuffix_1 = require("./getOrderLineTitleSuffix");
const getOrderLineTotal_1 = require("./getOrderLineTotal");
const isSummaryItem_1 = require("./isSummaryItem");
const getOrderLineWarnings_1 = require("./getOrderLineWarnings");
const expandedItemProcessor = (items, order, include_data, exchange_rate) => {
    return {
        order_lines: items
            .map((item) => {
            if ((0, isSummaryItem_1.isSummaryItem)(item)) {
                return {
                    line_type: "SUMMARY",
                    icon: (0, getOrderLineIcon_1.getOrderLineIcon)(item),
                    type: item.type,
                    region_id: item.region_id,
                    isSummaryLine: true,
                    region: item.region,
                    supplier_id: item.supplier_id,
                    order_weight: item.order_weight,
                    start_date: item.start_date,
                    status: item.status,
                    end_date: item.end_date,
                    title: item.title,
                };
            }
            else {
                if (!item.versions)
                    return null;
                const latest_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(item.versions);
                if (!latest_version)
                    return null;
                const has_linked_line = items.find((line) => {
                    if ((0, isSummaryItem_1.isSummaryItem)(line))
                        return false;
                    if (!line.versions)
                        return false;
                    const latest_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(line.versions);
                    return latest_version
                        ? latest_version.linked_line_id === item.id
                        : null;
                });
                const is_linked_line = latest_version?.linked_line_id !== undefined &&
                    latest_version?.linked_line_id !== null;
                const linked_line = items.find((line) => {
                    if ((0, isSummaryItem_1.isSummaryItem)(line))
                        return false;
                    return latest_version?.linked_line_id === line.id;
                });
                return {
                    id: item.id,
                    latest_version_id: latest_version.id,
                    latest_version: latest_version,
                    supplier_id: (0, getOrderLineSupplier_1.getOrderLineSupplier)(item),
                    order_id: item.order_id,
                    order_weight: item.order_weight,
                    type: item.type,
                    region_id: item.region_id,
                    region: item.region,
                    icon: (0, getOrderLineIcon_1.getOrderLineIcon)(item),
                    line_type: "LINE_ITEM",
                    start_date: latest_version.start_date,
                    end_date: latest_version.end_date,
                    title: `${(0, getOrderLineTitle_1.getOrderLineTitle)(item)}${(0, getOrderLineTitleSuffix_1.getOrderLineTitleSuffix)(item, order)}`,
                    warnings: (0, getOrderLineWarnings_1.getOrderLineWarnings)(item),
                    reminders: item.reminders,
                    notes: item.order_notes,
                    pax: (0, getOrderLinePax_1.getOrderLinePax)(item),
                    linked_line: linked_line ? (0, getOrderLineTitle_1.getOrderLineTitle)(linked_line) : null,
                    linked_line_type: linked_line ? linked_line.type : null,
                    is_linked_line: is_linked_line ? true : false,
                    has_linked_line: has_linked_line ? true : false,
                    linked_line_data: (0, getLinkedLineData_1.getLinkedLineData)(item, items),
                    total_price: (0, getOrderLineTotal_1.getOrderLineTotal)(item),
                    total_price_note: (0, getOrderLinePricingNote_1.getOrderLinePricingNote)(item),
                    total_price_formatted: (0, currencyFormatter_1.currencyFormatter)((0, getOrderLineCurrency_1.getOrderLineCurrency)(item) || "", (0, getOrderLineTotal_1.getOrderLineTotal)(item), false),
                    estimated: (0, getOrderLineEstimatedCheck_1.getOrderLineEstimatedCheck)(item),
                    isIncomplete: !(0, getOrderLineCompletionStatus_1.getOrderLineCompletionStatus)(item),
                    isSummaryLine: false,
                    currency: (0, getOrderLineCurrency_1.getOrderLineCurrency)(item),
                    display_currency: exchange_rate
                        ? (0, getOrderDisplayCurrency_1.getOrderDisplayCurrency)(exchange_rate)
                        : null,
                    display_total_price: exchange_rate
                        ? (0, getOrderLineDisplayTotal_1.getOrderLineDisplayTotal)(item, exchange_rate)
                        : null,
                    display_total_price_formatted: exchange_rate
                        ? (0, currencyFormatter_1.currencyFormatter)((0, getOrderDisplayCurrency_1.getOrderDisplayCurrency)(exchange_rate) || "", (0, getOrderLineDisplayTotal_1.getOrderLineDisplayTotal)(item, exchange_rate), false)
                        : null,
                    data: include_data ? (0, getOrderLineData_1.getOrderLineData)(item) : null,
                    descriptions: (0, getOrderLineDescriptions_1.getOrderLineDescriptions)(item),
                    status: latest_version.status,
                    created_at: dayjs().calendar(dayjs(latest_version.created_at)),
                };
            }
        })
            .sort((a, b) => {
            return (new Date(a.start_date).getTime() - new Date(b.start_date).getTime());
        }),
    };
};
exports.expandedItemProcessor = expandedItemProcessor;
